// extracted by mini-css-extract-plugin
export default {"timeline-item":"HistoryRecord_timeline-item__oIuXs","timeline-items":"HistoryRecord_timeline-items__H3PBY"};